import styled from 'styled-components'

export const DescriptionBoxWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`

export const ReadMoreWrapper = styled.div`
    display: flex;
    flex: 1;
    padding: 4px 0;
    margin-bottom: 12px;
`
